<template>
  <div>
    <a-modal v-model="visible" width="420px" :title="categoryId ? '修改分类' : '添加分类'" ok-text="确认" cancel-text="取消" :ok-button-props="{ props: { loading: loading } }" @ok="submit" @cancel="close">
      <a-form-model ref="modalForm" :model="modalForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="分类名称" prop="name">
          <a-input v-model="modalForm.name" />
        </a-form-model-item>
        <a-form-model-item label="分类排序" prop="sort">
          <a-input-number v-model="modalForm.sort" style="width: 100%" :min="1" :max="100000" :default-value="1" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { navigationCategoryModify, navigationCategoryAdd } from '@/api/system/navigation';

export default {
  name: 'TeamModal',
  props: {
    categoryId: {
      type: [Number, String],
      default: null
    },
    categoryData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      uplaadLoading: false,
      visible: this.isShow,
      labelCol: { span: 8 },
      wrapperCol: { span: 13 },
      modalForm: {
        logo: null
      },
      rules: {
        name: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }],
        sort: [{ required: true, message: '分类排序不能为空', trigger: 'blur' }]
      }
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.visible === true) {
        if (this.categoryId) {
          this.modalForm = {
            ...this.categoryData
          };
        } else {
          this.modalForm = {
            name: null,
            sort: 1
          };
        }
      }
    }
  },
  methods: {
    close() {
      this.loading = false;
      this.$emit('close', 'submit');
    },

    submit() {
      this.$refs.modalForm.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.categoryId) {
            this.loading = true;
            navigationCategoryModify({ id: this.categoryId, ...this.modalForm })
              .then(() => {
                this.loading = false;
                this.$message.success('分类修改成功');
                this.close();
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            navigationCategoryAdd(this.modalForm)
              .then(() => {
                this.loading = false;
                this.$message.success('分类添加成功');
                this.close();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    }
  }
};
</script>

<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
